import React from 'react';
import { Button, Modal, ModelCustom } from 'components/shared';
import DangerIcon from 'assets/images/items/danger.svg';
interface IConfirmationProps {
  visible: boolean;
  setVisible: any;
  accept?: () => void;
  message?: any;
  description?: any;
}

const Confirmation: React.FC<IConfirmationProps> = ({
  visible,
  setVisible,
  accept,
  //message = 'Confirmation required! Are you sure you wish to delete?',
  description = ' Please, rethink your decision because you will not be able to undo this action',
}) => {
  return (
    <div>
      <ModelCustom
        isOpen={visible}
        title='Are you sure you want to perform this action?'
        setIsOpen={setVisible}
        children={
          <div className='flex flex-col pb-4'>
            <div className='flex justify-center pb-4'>
              <div className='w-12 h-12 bg-gray-100 flex justify-center items-center rounded-md'>
                <img src={DangerIcon} alt='danger' className='w-8'/>
              </div>
            </div>
           
            <div className='font-poppinsMedium  text-gray-500 text-center text-p2 pb-6'>
              {description}
            </div>
            <div className='flex items-center justify-center md:justify-end gap-4'>
              <Button
                variant='secondary'
                name='X No'
                onClick={() => setVisible(false)}
              />
              <Button name='✓ Yes' onClick={accept} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default Confirmation;
